import { useParams } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { VideoPlayer } from "@/components/VideoPlayer";
import { useEffect, useState } from "react";

interface Item {
  title: string;
  sampleMovieURL?: {
    size_476_306?: string;
    size_560_360?: string;
    size_644_414?: string;
    size_720_480?: string;
    pc_flag?: number;
    sp_flag?: number;
  };
  sampleImageURL?: {
    sample_s?: {
      image?: string[];
    };
  };
}

interface GenreData {
  result: {
    items: Item[];
  };
}

export function GenrePage() {
  const { genre } = useParams<{ genre: string }>();
  const [data, setData] = useState<GenreData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGenreData = async () => {
      try {
        setLoading(true);
        const url = `/data/items_${genre}.json`;
        console.log("Fetching from URL:", url);
        const response = await fetch(url);
        console.log("Response status:", response.status);
        
        if (response.ok) {
          const jsonData = await response.json();
          console.log("Loaded data:", jsonData);
          setData(jsonData);
        } else {
          console.error("Failed to fetch:", response.status, response.statusText);
        }
      } catch (error) {
        console.error("Failed to load genre data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (genre) {
      loadGenreData();
    }
  }, [genre]);

  if (loading) {
    return (
      <div className="container mx-auto p-8 text-center">
        <p>Loading...</p>
      </div>
    );
  }

  if (!data || !data.result || !data.result.items) {
    return (
      <div className="container mx-auto p-8 text-center">
        <p>No data available for genre: {genre}</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-8">
      <h1 className="text-4xl font-bold text-center mb-8">Genre: {genre}</h1>
      <div className="grid gap-6">
        {data.result.items.map((item, index) => (
          <Card key={index} className="overflow-hidden">
            <CardContent className="p-6">
              <h2 className="text-2xl font-semibold mb-4">{item.title}</h2>
              
              <VideoPlayer 
                sampleMovieURL={item.sampleMovieURL}
                title={item.title}
                posterImage={item.sampleImageURL?.sample_s?.image?.[0]}
              />

              {item.sampleImageURL?.sample_s?.image && item.sampleImageURL.sample_s.image.length > 0 && (
                <Carousel className="w-full max-w-3xl mx-auto">
                  <CarouselContent>
                    {item.sampleImageURL.sample_s.image.map((imageUrl, imgIndex) => (
                      <CarouselItem key={imgIndex} className="md:basis-1/2 lg:basis-1/3">
                        <div className="p-1">
                          <img 
                            src={imageUrl} 
                            alt={`Sample ${imgIndex + 1}`}
                            className="w-full h-auto rounded-lg"
                          />
                        </div>
                      </CarouselItem>
                    ))}
                  </CarouselContent>
                  <CarouselPrevious />
                  <CarouselNext />
                </Carousel>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}